import DEFAULT_CONFIG from './DEFAULT_CONFIG'
import EVENTS from './EVENTS'
import ERROR_CODE from './ERROR_CODE'

const CORE = {
  DASH: 'DASH',
  HLS: 'HLS',
  MP4: 'MP4'
}

const VIDEO_FORMAT = [
  'video/webm',
  'video/mp4'
]

export {
  DEFAULT_CONFIG,
  EVENTS,
  ERROR_CODE,
  CORE,
  VIDEO_FORMAT
}
